import React from "react"
import ReactDOM from "react-dom"
import App from "./App"
import * as serviceWorker from "./serviceWorker"
import { BrowserRouter } from "react-router-dom"
import "./i18n"
import { Provider } from "react-redux"
import store from "./store"
import { isMobile } from "react-device-detect"
import localJsonData from "./assets/localdata.json"

const loader = document.querySelector(".loader")
const showLoader = () => loader.classList.remove("loader--hide")
const hideLoader = () => loader.classList.add("loader--hide")

const renderApp = () => {
  const app = (
    <Provider store={store}>
      <BrowserRouter>
        <App hideLoader={hideLoader} showLoader={showLoader} />
      </BrowserRouter>
    </Provider>
  )

  ReactDOM.render(app, document.getElementById("root"))
}

const fetchAndStoreData = async () => {
  const adminPanel = isMobile
    ? `${process.env.REACT_APP_ADMIN}`
    : `${process.env.REACT_APP_ADMIN_LAPTOP}`
  try {
    const response = await fetch(`${adminPanel}/getJD`)
    const data = await response.json()
    localStorage.removeItem("dataJ")
    localStorage.setItem("dataJ", JSON.stringify(data))
  } catch (error) {
    console.error("Failed to fetch data:", error)
  }
  hideLoader()
  renderApp()
}

showLoader()
fetchAndStoreData()
serviceWorker.unregister()